import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import useParcelStore from "./parcelStore";

const useAuthStore = create(
  devtools(
    persist(
      (set, get) => ({
        isLoggedIn: false,
        user: null,

        login: (userData) =>
          set({
            isLoggedIn: true,
            user: userData,
          }),

        logout: () => {
          // Clear user state
          set(() => ({
            isLoggedIn: false,
            user: null,
          }));

          useParcelStore.getState().clearParcel();
        },
      }),
      { name: "profile" }
    )
  )
);

export default useAuthStore;
